import { useCallback, useState } from "react";

type ReturnType = {
  loginEventCode: string;
  loginFormOpen: boolean;
  handleLoginToEvent: (eventCode: string) => boolean;
  handleLogout: () => void;
};

const VALID_EVENT_CODES = [
  "Deichman031125",
  "Deichman011225",
  "Frogner241125",
  "Tonsberg151125",
  "Tonsberg150826",
  "Tonsberg190926",
  "Lillestrom151125",
  "Sorumsand281125",
  "Drammen261125",
  "Trosterud271125",
  "Deichman050126",
  "Deichman020226",
  "Deichman030226",
  "Deichman040526",
  "Deichman010626",
  "Deichman070926",
  "Deichman051026",
  "Deichman021126",
  "Tonsberg211126",
  "220426",
  "240426",
  "260426",
];

const getTodayDateString = () => new Date().toISOString().slice(0, 10);
const getTodaySavedValidCode = (): string => {
  const today = getTodayDateString();
  const storedEventCode = localStorage.getItem(today);
  return storedEventCode && VALID_EVENT_CODES.includes(storedEventCode)
    ? storedEventCode
    : "";
};

const useRestarterEventLogin = (): ReturnType => {
  const [loginEventCode, setLoginEventCode] = useState(
    getTodaySavedValidCode(),
  );
  const [loginFormOpen, setLoginFormOpen] = useState(
    !Boolean(getTodaySavedValidCode()),
  );

  const handleLoginToEvent = useCallback((eventCode: string): boolean => {
    if (!eventCode || !VALID_EVENT_CODES.includes(eventCode)) {
      return false;
    }
    const today = getTodayDateString();
    localStorage.setItem(today, eventCode);
    setLoginEventCode(eventCode);
    setLoginFormOpen(false);

    return true;
  }, []);

  const handleLogout = useCallback(() => {
    const today = getTodayDateString();
    localStorage.removeItem(today);
    setLoginEventCode("");
    setLoginFormOpen(true);
  }, []);

  return {
    loginEventCode,
    loginFormOpen,
    handleLoginToEvent,
    handleLogout,
  };
};

export default useRestarterEventLogin;
